import { css } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const rmaStickyBar = css`
  .rma-sticky-bar__actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    gap: var(--spacing-s, 0.5rem);

    @media (min-width: ${SCREENS.extraSmall}) {
      flex-direction: row;
      align-items: center;
    }
  }
`
